<template lang="pug">
  #potential-establishments
    multiple-row-action(
      :selection-count="selectedEstablishmentIds.length"
      :actions="groupActions"
      :units="groupUnits"
      @add="addSelectedEstablishments"
      @selectAll="$refs.establishmentList.selectAll()"
      @deselectAll="$refs.establishmentList.deselectAll()"
    )
    establishment-list(
      ref="establishmentList"
      :establishments="potentialEstablishments"
      :actions="listActions"
      :selectable="true"
      :loading="loading"
      @add="addEstablishment"
      @selection="setSelectedEstablishmentIds"
      @hover="establishmentHoverHandler"
      @goToEstablishment="goToEstablishment"
    )
    add-establishments-modal(
      ref="addEstablishmentsModal"
      :establishment="establishment"
      @merge="$emit('update')"
    )
</template>

<script>
import EstablishmentList from '@/components/establishment-list/EstablishmentList.vue';
import MultipleRowAction from '@/components/MultipleRowAction.vue';
import AddEstablishmentsModal from './AddEstablishmentsModal.vue';
import establishmentService from '@/services/establishments.js';

export default {
  components: {
    EstablishmentList,
    MultipleRowAction,
    AddEstablishmentsModal,
  },
  props: {
    establishment: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      potentialEstablishments: [],
      listActions: [{ label: "Ajouter à l'établissement", event: 'add' }],
      groupActions: [{ label: "Ajouter $count $unit", event: 'add' }],
      groupUnits: { singular: 'établissement', plural: 'établissements'},
      selectedEstablishmentIds: [],
      loading: false,
    };
  },
  mounted () {
    this.getPotentialEstablishments();
  },
  methods: {
    async getPotentialEstablishments() {
      this.selectedSheetIds = [];
      this.loading = true;
      this.potentialEstablishments = await establishmentService.getPotentialByEstablishmentId(this.establishment.id);
      this.loading = false;
      this.$emit('getEstablishments', { establishments: this.potentialEstablishments });
    },
    setSelectedEstablishmentIds({ selected }) {
      this.selectedEstablishmentIds = selected;
    },
    addSelectedEstablishments() {
      const selectedEstablishments = this.potentialEstablishments.filter(it => this.selectedEstablishmentIds.includes(it.id));
      this.$refs.addEstablishmentsModal.establishments = selectedEstablishments;
    },
    addEstablishment({ establishmentId }) {
      const establishment = this.potentialEstablishments.find(it => establishmentId === it.id);
      this.$refs.addEstablishmentsModal.establishments = [establishment];
    },
    establishmentHoverHandler({ establishmentId }) {
      if (establishmentId) {
        const establishment = this.potentialEstablishments.find(it => establishmentId === it.id);
        this.$emit('hover', { establishment });
      } else {
        this.$emit('hover', { establishment: null });
      }
    },
    goToEstablishment({ establishmentId }) {
      this.$router.push(`/establishment/${establishmentId}`);
    },
  },
}
</script>

<style lang="scss">
  #potential-establishments {
    .establishment-list {
      &.empty,.load-content {
        min-height: 20em;
      }
    }
  }
</style>